module.exports = "https://static.cdns.space/tarot-temp/img/the-pope.c2649c09.webp";